// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2mCS6","infoBtn":"quickbooks_infoBtn__3a-cA","formBox":"quickbooks_formBox__9TiYT","formFooter":"quickbooks_formFooter__KXmIc"};